import React from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"
import { SelectOption } from "shared/types/Select"
import type { AttachmentType } from "shared/types/__generated__/graphql"

import { AttachmentLinkFormView } from "./AttachmentLinkFormView"
import { useAttachmentLinkFormViewModel } from "./model/useAttachmentLinkFormViewModel"

export interface AttachmentLinkFormModel {
  attachments: AttachmentType[] | null
  linkedAttachments: AttachmentType[] | null
  categories: SelectOption<string>[] | null

  getName: (attachment: AttachmentType) => string
  onUpload?: (
    file: FilePreview,
    category: string
  ) => Promise<ApiResponse<AttachmentType>> | void
}

export interface AttachmentLinkFormProps extends AttachmentLinkFormModel {
  isReadonly?: boolean
}

export const AttachmentLinkForm = React.memo(
  (props: AttachmentLinkFormProps) => {
    return <AttachmentLinkFormView {...useAttachmentLinkFormViewModel(props)} />
  }
)
